<template>
    <div class="buy-content" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <!-- 页面背景 -->
        <div class="page-background">
            <div class="page-background--shadow"></div>
            <img class="page-background--image" v-if="orderInfo.backgroundImage" :src="orderInfo.backgroundImage" />
            <img class="page-background--image" v-else src="../../assets/images/bg-default.jpg" />
        </div>
        <!-- 步骤 -->
        <div class="step-box">
            <div class="step-item">
                <img src="../../assets/images/active-1.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/active-point.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/active-2.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/active-point.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/active-3.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/active-point.png">
            </div>
            <div class="step-item">
                <img src="../../assets/images/4.png">
            </div>
        </div>
        <!-- 门票内容 -->
        <div class="ticket-content">
            <!-- 门票信息 -->
            <div class="ticket-list" v-if="orderInfo.ticketBuyerList && orderInfo.ticketBuyerList.length">
                <div class="ticket-box" v-for="(item, index) in orderInfo.ticketBuyerList" :key="index"
                    v-if="item.ticketTotalNum">
                    <div class="ticket-display">
                        <div class="half-circle">
                            <div class="circle-left"></div>
                            <div class="circle-right"></div>
                        </div>
                        <img class="image" :src="item.image">
                        <div class="ticket-right">
                            <div class="title">{{ item.name }}</div>
                            <div class="title">{{ item.englishName }}</div>
                            <div class="text">预约门店：{{ orderInfo.storeName }}</div>
                            <div class="text">日期：{{ orderInfo.activityDate }}</div>
                            <div class="text">预约入场时间：{{ orderInfo.timeSlotText }}</div>
                            <div class="text">票时长：{{ orderInfo.ticketDurationMinutes === 0 ? '全天' :
                                orderInfo.ticketDurationMinutes + '分钟' }}</div>
                            <!-- 添加门票数量 -->
                            <div class="ticket-detail">
                                <div class="num">X{{ item.ticketTotalNum }}</div>
                                <div class="money">￥{{ item.ticketTotalNum * item.money }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="return-btn" type="primary" plain @click="goBack">
                <div class="cn">返回</div>
                <div class="en">Return</div>
            </el-button>
            <!-- PC端 -->
            <el-button class="btn-pc" type="primary" @click="putTransactionOrder">
                <div class="confirm-btn">
                    <div class="totalMoney" v-if="totalMoney">￥{{ totalMoney }}</div>
                    <div>
                        <div class="cn">購買</div>
                        <div class="en">BUY NOW</div>
                    </div>
                </div>
            </el-button>
            <!-- 手机端 -->
            <el-button class="btn-mobile" type="primary" @click="putTransactionOrder">
                <div class="confirm-btn">
                    <div class="totalMoney" v-if="totalMoney">￥{{ totalMoney }}</div>
                    <div>
                        <div class="cn">購買</div>
                        <div class="en">BUY NOW</div>
                    </div>
                </div>
            </el-button>
        </div>

        <!-- 支付二维码弹窗 -->
        <div class="popup-content" v-if="isPopupPay" @click="cancelPopupPay">
            <div class="popup-box qrcode-box" @click.stop>
                <img class="title" src="https://pdsite.partydaysport.com/official_website/buyTickets/pay-title.png">
                <div id="qrcode" ref="qrcode"></div>
                <div class="qrcode-text">
                    <div>Please use WeChat/Alipay to scan the code</div>
                    <div>Check my ticket after successful payment</div>
                    <div>請使用微信/支付寶掃碼，支付成功後前往我的門票進行查看</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import {
    putTransactionOrderV3
} from "@/api/activity";
import { getOrderStatus } from "@/api/index";
export default {
    data() {
        return {
            orderInfo: {},//订单信息
            isPopupPay: false,//支付二维码弹窗
            statusTimeout: null,//1秒倒计时
            loading: false, // 加载状态
            isPaySuccess: false,//是否支付成功
        }
    },
    computed: {
        // 共计交易金额
        totalMoney() {
            if (!this.orderInfo.ticketBuyerList) return
            let sum = 0;
            this.orderInfo.ticketBuyerList.forEach(item => {
                sum += (item.ticketTotalNum * item.money);
            });
            return sum;
        },
    },
    mounted() {
        // 订单信息回显
        this.orderInfo = JSON.parse(localStorage.getItem('orderInfo'))
    },
    beforeDestroy() {
        if (this.statusTimeout) {
            clearInterval(this.statusTimeout);
            this.statusTimeout = null;
        }
    },
    methods: {
        // 返回
        goBack() {
            this.$router.back()
            localStorage.removeItem('orderInfo');
        },
        // 账户过期处理
        message405(res) {
            if (res.data.code == 405) {
                this.$notify({
                    title: '帳號過期請重新登入',
                    type: 'error'
                });
                localStorage.removeItem('satoken')
                this.$router.replace('/')
            } else {
                this.$notify({
                    title: res.data.message || res.data.msg,
                    type: 'error'
                });
            }
        },
        // 发起门票活动交易v3
        putTransactionOrder(type) {
            this.loading = true
            const ticketBuyerList = this.orderInfo.ticketBuyerList
                .filter(item => item.ticketTotalNum > 0)
                .map(ticket => ({
                    participantId: ticket.id,
                    ticketNum: ticket.ticketTotalNum
                }))
            putTransactionOrderV3({
                storeId: this.orderInfo.storeId,//门店ID
                entryTime: this.orderInfo.entryTime,//预约入场时间
                ticketDurationMinutes: this.orderInfo.ticketDurationMinutes,//票时长，单位分钟，0表示全天
                ticketBuyerList,//购票人列表
                payType: 2,//支付类型
                bookingChannel: 3,//预约渠道——网站
            })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$notify({
                            title: '下單成功，快掃碼支付吧~',
                            type: 'success',
                            duration: 3000
                        });

                        this.isShowQrcode(res.data.data.payUrl)//生成二维码
                        this.getScanCodeStatus(res.data.data.orderRn)//每秒刷新订单状态

                    } else {
                        this.message405(res)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 显示二维码
        isShowQrcode(payUrl) {
            this.isPaySuccess = false
            this.isPopupPay = true
            this.$nextTick(() => {
                this.$refs.qrcode.innerHTML = "";
                this.qrcodeWechat(300, 300, payUrl, "canvas");
            });
        },
        // 每秒刷新扫码状态
        getScanCodeStatus(orderRn) {
            if (this.isPaySuccess || !this.isPopupPay) {
                return;
            }
            getOrderStatus({
                orderRn
            }).then(res => {
                if (res.data.code == 200) {
                    this.cancelPopupPay()
                    sessionStorage.removeItem('buyTicketInfo');
                    localStorage.removeItem('orderInfo');
                    // 跳转到我的门票页面，发起提醒弹窗
                    this.$router.push({
                        path: '/myTicket',
                        query: {
                            status: 'buy',
                        }
                    });
                } else {
                    if (this.statusTimeout == null && this.isPopupPay) {
                        this.scanCodeStatusSetTimeout(orderRn)
                    }
                }
            });
        },
        // 每秒刷新一下
        scanCodeStatusSetTimeout(orderRn) {
            this.statusTimeout = setInterval(() => {
                this.getScanCodeStatus(orderRn)
            }, 2000)
        },
        // 关闭支付二维码弹窗
        cancelPopupPay() {
            if (this.statusTimeout) {
                clearInterval(this.statusTimeout)
                this.statusTimeout = null
            }
            this.isPopupPay = false
            this.isPaySuccess = false
        },
        // 二维码生成
        qrcodeWechat(qWidth, qHeight, qText, qRender) {
            new QRCode("qrcode", {
                width: qWidth,
                height: qHeight,
                text: qText,
                render: qRender,
            });
        },
    }

}
</script>
<style lang="less">
.buy-content {
    width: 100%;
    min-height: 100vh;
    background-color: #000;
    padding: 20px 50px 100px;
    box-sizing: border-box;
    color: #fff;

    .btn-mobile {
        display: none;
    }

    .el-button--primary {
        background-color: #fff;
        border-color: #fff;
        color: #000;
    }

    .el-button--primary.is-plain {
        background-color: #000;
        border-color: #fff;
        color: #fff;
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: #fff;
        border-color: #fff;
        color: rgba(0, 0, 0, .8);
    }

    .el-button--primary.is-plain:hover,
    .el-button--primary.is-plain:focus {
        background-color: #000;
        border-color: rgba(255, 255, 255, .8);
        color: rgba(255, 255, 255, .8);
    }

    .page-background {
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        left: calc(50% + 20px);

        .page-background--shadow {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: linear-gradient(to right, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%);
            z-index: 1;
        }

        .page-background--image {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            object-fit: cover;
        }
    }

    .dialog-footer {
        width: calc(40% + 10px);
        position: fixed;
        left: 0;
        bottom: 0;
        padding: 20px 0 20px 50px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        background-color: #000;
        z-index: 100;

        .confirm-btn {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .totalMoney {
                font-size: 30px;
                font-weight: bold;
                margin-right: 20px;
            }
        }

        .el-button {
            width: 65%;
        }

        .return-btn {
            width: 30% !important;
        }
    }

    .step-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .step-item {
            width: 22%;

            img {
                width: 100%;
                height: auto;
            }
        }

        .step-item:nth-child(2n) {
            width: 4%;
        }

    }


    .ticket-content,
    .step-box {
        width: 40%;
        min-width: 300px;
    }

    .ticket-list {
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;

        .ticket-name {
            font-size: 20px;
            font-weight: bold;
        }

        .ticket-box {
            width: 100%;
            margin: 10px 0;
            min-width: 300px;
            padding: 10px 20px;
            box-sizing: border-box;
            border-radius: 10px;
            background-color: #fff;
            color: #000;
            position: relative;

            .ticket-display {
                width: 100%;
                height: 100%;
                display: flex;

                .half-circle {
                    position: absolute;
                    left: 0;
                    top: 45%;
                    margin: auto;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    .circle-right,
                    .circle-left {
                        width: 15px;
                        height: 30px;
                        background-color: #000;
                    }

                    .circle-right {
                        border-radius: 15px 0 0 15px;
                    }

                    .circle-left {
                        border-radius: 0 15px 15px 0;
                    }
                }

                .image {
                    width: 140px;
                    height: 100%;
                    object-fit: fill;
                    border-radius: 5px;
                }

                .ticket-right {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    font-size: 10px;
                    padding: 0 10px;
                    box-sizing: border-box;

                    .title {
                        width: 100%;
                        font-size: 15px;
                    }

                    .text {
                        width: 100%;
                        font-size: 14px;
                    }

                    .ticket-detail {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .money,
                        .num {
                            font-size: 20px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }

    .popup-content {
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        z-index: 100;
        position: fixed;
        left: 0;
        top: 0;
        color: #000;

        .popup-box {
            width: 500px;
            height: 500px;
            max-width: 90%;
            background-color: #fff;
            border-radius: 15px;
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            padding: 10px;
            box-sizing: border-box;
        }

        .qrcode-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 30px;

            .title {
                width: 70%;
                height: auto;
            }

            .qrcode-text {
                text-align: center;
                font-size: 12px;
            }
        }
    }
}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {
    .buy-content {
        padding: 20px;
        padding-bottom: 70px;

        .btn-pc {
            display: none;
        }

        .btn-mobile {
            display: block;
        }

        .page-background {
            display: none;
        }

        .ticket-content,
        .step-box {
            width: 100% !important;
        }


        .dialog-footer {
            width: 100%;
            padding: 20px;
            min-width: 300px;

        }

        .totalMoney {
            font-size: 20px !important;
        }

        .ticket-right {

            .text {
                font-size: 14px !important;
            }
        }

        .ticket-display .image {
            width: 100px !important;
        }
    }

}
</style>